import {ReplaySubject} from 'rxjs';
import {yieldToMain} from '../common/util';

/**
 * @callback TrackerDataLayer~TrackersCallback
 * @param {BTTrackersManager} trackers
 */

export class TrackerDataLayer {
  constructor({subject = new ReplaySubject(), trackers, initialData = []}) {
    this.subject = subject;
    this.trackers = trackers;
    this._actionHandler = this._actionHandler.bind(this);

    this.subject.subscribe({next: this._actionHandler});

    initialData.forEach(val => this.push(val));
  }

  /**
   * Pushes an action onto the data layer, to be processed by the BTTrackersManager.
   * @param {TrackerDataLayer~TrackersCallback} action
   */
  async push(action) {
    let val = action;
    if (typeof (action) === 'function') {
      val = {action};
    }
    this.subject.next(val);
    await yieldToMain();
  }

  _actionHandler({action, ...rest}) {
    if (typeof (action) === 'function') {
      try {
        action(this.trackers);
      } catch (err) {
        console.error('Error in trackers action', action, err);
      }
    } else {
      console.error(
        'Tracker Data Layer object must contain key \'action\', which must be callable.', {action, ...rest},
      );
    }
  }
}
